export const Icon = ({ nav, children }) => <div className={`icon ${nav ? 'icon-nav' : ''}`}>{children}</div>;
